import { useState } from "react";
import Button from "../../../../componentes/button/button";
import AcaoButtons from "../../Shared/AcaoButtons";

function PerguntaSimNao({ pergunta, valor, onChange }) {
    return (
        <div className="flex items-center gap-3 flex-wrap">
            <span className="text-sm font-medium text-foreground/80 min-w-48">
                {pergunta} <span className="text-destructive">*</span>
            </span>
            <div className="flex gap-2">
                <Button variant={valor === true ? "green" : "outline"} label="Sim" onClick={() => onChange(true)} />
                <Button variant={valor === false ? "red" : "outline"} label="Não" onClick={() => onChange(false)} />
            </div>
        </div>
    );
}

// Reutilizado por Lançamento de Despesa (etapa 4) e Solicitação de Compras (etapa 9). Duas perguntas:
// "Pagamento realizado?" só fica registrado; quem decide o fluxo é "Possui pendência?" — o financeiro
// pode ter pago e ainda assim ficar pendente para baixa (ex.: sem nota). Com pendência, exige o motivo
// e envia REGISTRAR_PENDENCIA (vai para Regularização de Documentação → Confirmação da Baixa);
// sem pendência, envia CONCLUIR e finaliza.
export default function EtapaConfirmacaoPagamento({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [pago, setPago] = useState(null);
    const [pendente, setPendente] = useState(null);
    const [motivo, setMotivo] = useState("");
    const podeConcluir = acoes.includes("CONCLUIR");
    const outrasAcoes = acoes.filter(a => a !== "CONCLUIR" && a !== "REGISTRAR_PENDENCIA");
    const bloqueado = pago === null || pendente === null || (pendente && !motivo.trim());
    const acaoAoEnviar = pendente ? "REGISTRAR_PENDENCIA" : "CONCLUIR";

    return (
        <div className="flex flex-col gap-4">
            {podeConcluir && (
                <div className="flex flex-col gap-3">
                    <PerguntaSimNao pergunta="Pagamento realizado?" valor={pago} onChange={setPago} />
                    <PerguntaSimNao pergunta="Possui pendência?" valor={pendente} onChange={setPendente} />
                    {pendente && (
                        <div className="flex flex-col gap-1.5">
                            <label className="text-sm font-medium text-foreground/80">
                                Motivo da pendência <span className="text-destructive">*</span>
                            </label>
                            <textarea
                                rows={2}
                                value={motivo}
                                onChange={e => setMotivo(e.target.value)}
                                placeholder="Ex.: nota fiscal não anexada"
                                className="w-full px-3 py-2 border border-input rounded-lg text-sm outline-none transition-colors duration-150 focus:border-primary focus:ring-2 focus:ring-primary/15"
                            />
                        </div>
                    )}
                    {pendente !== null && (
                        <p className="text-xs text-muted-foreground">
                            <i className="fa fa-info-circle mr-1" />
                            {pendente
                                ? "A solicitação seguirá para Regularização de Documentação até a baixa ser confirmada."
                                : "A solicitação será finalizada."}
                        </p>
                    )}
                </div>
            )}

            <div className="flex justify-end gap-2 flex-wrap">
                <AcaoButtons acoes={outrasAcoes} acaoEmExecucao={acaoEmExecucao} onAcao={onExecutarAcao} />
                {podeConcluir && (
                    <Button
                        variant={pendente ? "blue" : "green"}
                        label={pendente ? "Enviar" : "Concluir"}
                        iconLeft={pendente ? "fa fa-paper-plane" : "fa fa-flag-checkered"}
                        disabled={bloqueado}
                        loading={acaoEmExecucao === acaoAoEnviar}
                        onClick={() => onExecutarAcao(acaoAoEnviar, {
                            dados: pendente
                                ? { pagamentoRealizado: pago, motivoPendencia: motivo.trim() }
                                : { pagamentoRealizado: pago },
                        })}
                    />
                )}
            </div>
        </div>
    );
}
